<template>
  <div>
    <v-card class="mx-auto">
      <v-card-title>
        {{ title }} 推荐
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <div v-for="(t,i) in list" :key="i" class="item-class">

          <div class="item-img-list-class">
            <div v-for="(item,index) in t.list" :key="index" class="mx-3">
              <div>
                <v-tooltip bottom color="#161a20">
                  <template v-slot:activator="{ on, attrs }">
                    <v-avatar v-bind="attrs"
                              v-on="on" tile>
                      <img
                          :src="item.img"
                          alt=""
                      >
                    </v-avatar>
                  </template>
                  <div class="px-3">
                    <span class="py-2" style="color:#9c8250;">{{ item.name }}</span>
                    <v-divider light/>
                    <div class="py-2" v-html="item.description"></div>
                  </div>
                </v-tooltip>
              </div>
            </div>
          </div>


          <div class="item-pickRate-class">
            <span style="color:#1dbaa9;">{{ t.pickRate }}%</span>
            <div>登场率</div>
          </div>

          <div class="item-winRate-class">
            <span style="color:#9c8250;">{{ t.winRate }}%</span>
            <div>胜率</div>
          </div>

        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "Item",
  props: {
    list: {
      type: Array,
      default: () => []
    },
    title: undefined,
  }
}
</script>

<style scoped>

.item-class {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  margin: 10px;
}

.item-img-list-class {
  display: flex;
  justify-content: flex-start;
}

.item-pickRate-class {
  width: 25%;
  text-align: center;
}

.item-winRate-class {
  width: 25%;
  text-align: center;
}
</style>
